import { useEffect, useState } from 'react'
import { supabase } from '../../supabaseClient'
import {
  widgetCardStyle,
  labelStyle,
  valueStyle,
  footerStyle,
} from '../styles/widgetStyles'

function PlansThisWeekWidget() {
  const [count, setCount] = useState(0)
  const [hover, setHover] = useState(false)

  useEffect(() => {
    const now = new Date()
    const startOfWeek = new Date(now)
    startOfWeek.setDate(now.getDate() - now.getDay())
    startOfWeek.setHours(0, 0, 0, 0)

    const fetchCount = async () => {
      const { count, error } = await supabase
        .from('plans_test')
        .select('*', { count: 'exact', head: true })
        .gte('last_upload_date', startOfWeek.toISOString())

      if (!error) setCount(count)
    }

    fetchCount()
  }, [])

  return (
    <div
      style={widgetCardStyle(hover)}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div style={labelStyle}>
        📥 Plans This Week <span title="Number of plans uploaded since Sunday.">ℹ️</span>
      </div>
      <div style={valueStyle}>{count}</div>
      <div style={footerStyle}>Uploaded since Sunday</div>
    </div>
  )
}

export default PlansThisWeekWidget
